function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardOverviewConfigured = function SvgNewcsDashboardOverviewConfigured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m13.48 5.73-3.6 4.39-2.22-2.23",
    style: {
      fill: "none",
      stroke: "#807997",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.28.19H1.34C.6.19 0 .77 0 1.48c0 .34.14.65.39.9 0 .02.03.03.05.05l4.41 4.24s.02.02.02.04v4.5c0 .15.07.28.18.37l2.77 2.12c.1.07.19.1.31.1.07 0 .15 0 .2-.04.18-.08.28-.24.28-.43v-1.61c-.2-.05-.39-.13-.57-.21-.14-.06-.27-.14-.4-.21v1.06l-1.81-1.37V6.71c0-.26-.11-.52-.3-.7L1.15 1.8s-.04-.05-.06-.07a.35.35 0 0 1-.11-.24c0-.19.17-.35.36-.35h10.93c.2 0 .37.16.37.35 0 .09-.04.18-.1.23l-.05.05-2.48 2.38c.4.02.78.11 1.13.25l2.06-1.99.04-.04c.24-.24.37-.55.37-.89 0-.71-.6-1.29-1.34-1.29Z",
    style: {
      fill: "#807997"
    }
  }));
};
export default SvgNewcsDashboardOverviewConfigured;